import { groq } from 'next-sanity';
import { z } from 'zod';

import { link, SanityLink } from './link';
import { media, SanityMedia } from './media';

export const SanityImageGridItem = z.object({
  _key: z.string(),
  media: SanityMedia,
  title: z.string(),
  description: z.string(),
  link: SanityLink.optional().nullable(),
});
export type SanityImageGridItem = z.infer<typeof SanityImageGridItem>;

export const SanityImageGrid = z.object({
  sectionIndex: z.number().optional().nullable(),
  _type: z.literal('imageGrid'),
  _key: z.string(),
  theme: z.enum(['light', 'dark', 'charcoal', 'purple']),
  eyebrow: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  cta: SanityLink.optional().nullable(),
  items: z.array(SanityImageGridItem),
});
export type SanityImageGrid = z.infer<typeof SanityImageGrid>;

export const imageGrid = groq`{
  _type,
  _key,
  "theme": select(theme == "dark" => "charcoal", coalesce(theme, "charcoal")),
  eyebrow,
  title,
  description,
  cta[0] ${link},
  items[] {
    _key,
    media[0] ${media},
    title,
    description,
    link[0] ${link},
  },
}`;
